import { clone, fromPairs, forIn, constant, assign } from "lodash";

import { isEffectivelyEmpty } from "../framework/Forms";
import ActualGame from "./ActualGame";
import ActualGameProcess from "./ActualGameProcess";
import GameClient from "../../ui/GameClient";
import drunkPlayer from "../bots/drunkPlayer";
import pickRandomOption from "../bots/pickRandomOption";

/* apply this function to a Game object to implement 'instantly' bot */
function implementInstantActions(game) {
  return game
    .setTurning(function(state, v, r) {
        r = clone(r);
        r.subj = "instantly";
        var fr = this.getFormReaction(r);
        if(!fr) return r.subj = undefined;
        var form = fr.form;
        if(form.type == "TimeForm") form = form.form;
        if(!isEffectivelyEmpty(form)) {
          return "instantly";
        } else {
          return r.subj = undefined;
        }
      });
}

function firstNonemptyTurn(subjects) {
  return function(state) {
    var active_subjects = subjects.filter(function(subj) {
      var fr = this.getFormReaction(state);
      if(!fr) return false;
      return (fr.form.type != "EmptyForm");
    });
    if(active_subjects.length == 0) return undefined;
    return active_subjects[0];
  }
}



// playerroles - array of subjects or a function, see Game.foldSubjects
// botsroles - object { subj: bot } or array of subjects
function GameClientInit(playerroles, botsroles) {

  if(botsroles instanceof Array) {
    botsroles = fromPairs(botsroles.map(function(role) { return [role, pickRandomOption]; }));
  }
  // 1.1. implement 'instantly'
  implementInstantActions(ActualGame);
  // 1.2. implement bots
  forIn(botsroles, function (bot, subj) {
    ActualGame.implementBot(subj, bot);
  });
  // 1.3. supply forms with msg
  // ActualGame.supplyMessage();
  // 2.1. specify subjects (roles) the player plays
  // ActualGame.foldSubjects(playerroles, "Player");
  // 2.3. set player's turn
  ActualGame.setTurning(constant("Player"));
  
  // 3. turn on recording
  ActualGame.stateRecording();
  
  var InitialState = {
    process: ActualGameProcess,
    subj: "instantly",
    objects: { difficulty: 0, prcType: "main" },
    istate: {},
    msg: {},
    curTime: 0,
    timestamps: { "Player": 0 }
  };
  
  GameClient.init(ActualGame, InitialState);
  
  drunkPlayer("instantly");
  
}

export default GameClientInit;
